exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".newMessage-987cef26{margin-bottom:20px}.content-548f637a{font-size:15px;margin-bottom:5px}.row-87e5b79e{cursor:pointer}.hovered-254d2323{background-color:#eee}.createdAt-ef72ee1c{font-size:13px;color:#616161;line-height:20px}.messages-84f7328b{padding:0px}.messages-84f7328b>.row-87e5b79e{border-bottom:2px solid #E0E0E0;padding:20px}.messages-84f7328b>.row-87e5b79e:last-child{border-bottom:0px}.empty-2c030a8c{height:400px;display:flex;flex-flow:column wrap;align-items:center;justify-content:center}.explainer-d256b3f9{padding-top:20px}\n", ""]);

// Exports
exports.locals = {
	"newMessage": "newMessage-987cef26",
	"content": "content-548f637a",
	"row": "row-87e5b79e",
	"hovered": "hovered-254d2323",
	"createdAt": "createdAt-ef72ee1c",
	"messages": "messages-84f7328b",
	"empty": "empty-2c030a8c",
	"explainer": "explainer-d256b3f9"
};